import { Dialog } from '@infotech-soe/erp-ui-kit';
import React, { useReducer } from 'react';
import { useIntl } from 'react-intl';

import DocLinksGraph from './DocLinksGraph';
import { DocLinksGraphDialogContainerProps } from './DocLinksGraphDialogContainer';
import { dialogMessages } from './messages';
import { useDialogStyles } from './styles';

const DocLinksGraphDialog = ({
  show,
  onClose,
  ...graphProps
}: DocLinksGraphDialogContainerProps): React.JSX.Element | null => {
  const { formatMessage } = useIntl();
  const classes = useDialogStyles();

  const [needsRefresh, setNeedsRefresh] = useReducer(x => x + 1, 0);

  if (!show) {
    return null;
  }

  return (
    <Dialog
      className={classes.dialog}
      open
      resizable
      title={formatMessage(dialogMessages.title)}
      onClose={onClose}
      onMoveStop={setNeedsRefresh}
      onResizeStop={setNeedsRefresh}
    >
      <DocLinksGraph {...graphProps} needsRefresh={needsRefresh} />
    </Dialog>
  );
};

export default DocLinksGraphDialog;
